var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.916626 11.0833C0.916626 11.0833 4.58329 3.75001 11 3.75001C17.4166 3.75001 21.0833 11.0833 21.0833 11.0833C21.0833 11.0833 17.4166 18.4167 11 18.4167C4.58329 18.4167 0.916626 11.0833 0.916626 11.0833Z",
    stroke: "#00A3FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.8333C12.5188 13.8333 13.75 12.6021 13.75 11.0833C13.75 9.56456 12.5188 8.33334 11 8.33334C9.48122 8.33334 8.25 9.56456 8.25 11.0833C8.25 12.6021 9.48122 13.8333 11 13.8333Z",
    stroke: "#00A3FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0833435,
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.de2ed5d60b5ffa30bd97a8a450c75e0a.svg";
export { ForwardRef as ReactComponent };